import { Stack, Text } from "@certn/cascadia-react";
import { useMediaQuery } from "@certn/cascadia-react/hooks/useMediaQuery";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { breakpoints } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsWithChildren, ReactNode } from "react";
interface Props extends PropsWithChildren {
  actions?: ReactNode;
  isLoading?: boolean;
  betaBadge?: ReactNode;
  headingId?: string;
}

export function PageTitle({
  actions,
  children,
  isLoading,
  betaBadge,
  headingId,
}: Props) {
  const isMobile = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-sm"].maxWidth.toString()}px)`
  );

  if (isLoading) {
    return (
      <Stack
        orientation="horizontal"
        align="center"
        className={styles.container}
      >
        <Skeleton width="120px" />
        {actions && <Skeleton width="120px" />}
      </Stack>
    );
  }

  return (
    <Stack orientation="horizontal" align="center" className={styles.container}>
      <Stack orientation="horizontal" align="center" gap="space-2">
        <Text
          style={isMobile ? "global/title-small" : "global/title-medium"}
          truncate
          id={headingId}
          as="h1"
          tabIndex={headingId ? -1 : undefined}
        >
          {children}
        </Text>
        {betaBadge}
      </Stack>
      {actions}
    </Stack>
  );
}

const styles = {
  container: css({
    "&[data-orientation=horizontal]": {
      justifyContent: "space-between",
      gap: "var(--space-2)",
    },
    flexWrap: "wrap",
  }),
};
